// import React, { useState } from "react";
// import {
//   Button,
//   TextField,
//   FormControl,
//   FormLabel,
//   Radio,
//   RadioGroup,
//   FormControlLabel,
// } from "@mui/material";
// import { Link } from "react-router-dom";
// import OTP from "./OTP";
// import { red } from "@mui/material/colors";
// import SignUpHome from "./assets/SignUpHomeImage.png";
// import Logo from "./assets/Group 1261153494.png";
// import "./addinfo.css";
// import { useLocation, useNavigate } from "react-router-dom";
// import APICall from "./Utility/APICall";
// import { paths } from "./Utility/Constants";
// import { useUser } from "./Utility/UserProvider";

// export default function AddInfo() {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { storeUser } = useUser();

//   const [firstName, setFirstName] = useState("");
//   const [lastName, setLastName] = useState("");
//   // const [accessToken, setAccessToken] = useState(''); // Set the access token

//   // const user = location.state ? location.state.user : {};
//   const token = location.state ? location.state.token : "";

//   const validateInput = (input) => {
//     // Define a regular expression pattern for allowed characters
//     const pattern = /^[a-zA-Z\s]*$/;
//     return pattern.test(input);
//   };

//   const handleUpdateUserInfo = async () => {
//     const apiUrl = `https://renown-backend-assignment.el.r.appspot.com/user/update`;

//     const body = {
//       first_name: firstName,
//       last_name: lastName,
//     };
//     const requestBody = body instanceof FormData ? body : new FormData();
//     if (typeof body === "object" && !(body instanceof FormData)) {
//       for (const key in body) {
//         if (Object.hasOwnProperty.call(body, key)) {
//           requestBody.append(key, body[key]);
//         }
//       }
//     }

//     try {
//       const response = await APICall(
//         "PUT",
//         paths.user.update,
//         requestBody,
//         undefined,
//         "Bearer " + token
//       );
//       if (response.status == "success") {
//         storeUser(response.response);
//         console.log(
//           "User data updated successfully:",
//           response.response.entity_id
//         );
//         navigate("/", { state: { token: token } });
//       }
//     } catch (error) {
//       // Handle network or other errors
//       console.error("Error:", error.message);
//     }
//   };

//   return (
//     <div className="flex" style={{ height: "100vh" }}>
//       <div
//         className="part1"
//         style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
//       >
//         <div className="part1-img-container">
//           <img src={SignUpHome} height={121} width={260} alt="RentPe Logo" />{" "}
//           {/* Add alt attribute for accessibility */}
//         </div>
//         <div>
//           <p
//             className="px-10"
//             style={{ fontSize: 40, fontWeight: 700, color: "white" }}
//           >
//             <strong>Rent</strong> management made <strong>easy</strong> on{" "}
//             <strong>RentPe</strong>
//           </p>
//         </div>
//         <section className="mt-auto w-full text-center p-4 text-white">
//           {" "}
//           {/* Footer styling */}
//           <p className="pb-4">
//             <Link to="/privacy-policy">Privacy Policy</Link>
//           </p>
//           <span>© 2024 RentPe. All rights reserved.</span>
//         </section>
//       </div>

//       <div className="pl-24" style={{ flex: 0.8 }}>
//         <div className="logo-signup-login pt-36 pb-12">
//           <img src={Logo} alt="Logo" width={130} height={130} />
//         </div>
//         <p style={{ fontSize: 24, fontWeight: 600 }}>Add your Info</p>
//         <div className="flex flex-col w-96 py-10 gap-10">
//           <TextField
//             id="first-name"
//             label="First Name"
//             variant="outlined"
//             error={!validateInput(firstName)}
//             helperText={!validateInput(firstName) ? "Invalid input" : ""}
//             InputProps={{
//               inputProps: {
//                 pattern: "^[A-Z][a-zA-Z\\s]*$",
//               },
//             }}
//             onChange={(e) => setFirstName(e.target.value)}
//           />
//           <TextField
//             id="last-name"
//             label="Last Name"
//             variant="outlined"
//             error={!validateInput(lastName)}
//             helperText={!validateInput(lastName) ? "Invalid input" : ""}
//             inputProps={{
//               pattern: "^[A-Za-z\\s]*$",
//             }}
//             onChange={(e) => setLastName(e.target.value)}
//           />
//         </div>
//         <p className="pb-10 w-96 text-xs">
//           By selecting Confirm and Continue, I agree to RentPe Terms of Services
//           and acknowledge the Privacy Policy.
//         </p>
//         <Button
//           className="w-96 h-12"
//           variant="contained"
//           onClick={handleUpdateUserInfo}
//         >
//           Confirm and Continue
//         </Button>
//       </div>
//     </div>
//   );
// }

// AddInfo.js
import React, { useState, useEffect } from "react";
import {
  Button,
  TextField,
  // Removed unused MUI components: FormControl, FormLabel, Radio, RadioGroup, FormControlLabel,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom"; // Removed useLocation if not using location.state
// import OTP from "./OTP"; // Unused import
// import { red } from "@mui/material/colors"; // Unused import
import SignUpHome from "./assets/SignUpHomeImage.png";
import Logo from "./assets/Group 1261153494.png";
import "./addinfo.css";
import APICall from "./Utility/APICall";
import { paths } from "./Utility/Constants";
import { useAuth } from "./Utility/AuthProvider"; // <--- IMPORT useAuth

// Removed: import { useUser } from "./Utility/UserProvider";

export default function AddInfo() {
  const navigate = useNavigate();
  const { user, jwt, updateUserInContext } = useAuth(); // <--- GET user, jwt, and updateUserInContext from AuthProvider

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Pre-fill form if user data exists in context but names are missing (e.g., browser refresh on this page)
  useEffect(() => {
    if (user) {
      // Though ProtectedRoute should handle redirection if names are already present,
      // this is defensive if user lands here and context has partial data.
      if (user.first_name) setFirstName(user.first_name);
      if (user.last_name) setLastName(user.last_name);
    }
  }, [user]);

  const validateInput = (input) => {
    const pattern = /^[a-zA-Z\s]*$/; // Allows letters and spaces
    return pattern.test(input) || input === ""; // Allow empty string during typing
  };

  const handleUpdateUserInfo = async () => {
    setError("");
    if (
      !firstName.trim() ||
      !lastName.trim() ||
      !validateInput(firstName) ||
      !validateInput(lastName)
    ) {
      setError("Please enter valid first and last names.");
      return;
    }
    if (!jwt) {
      setError("Authentication token is missing. Please log in again.");
      // navigate("/"); // Optionally redirect to login
      return;
    }

    setLoading(true);

    const body = {
      first_name: firstName.trim(),
      last_name: lastName.trim(),
    };

    // APICall should ideally handle FormData creation internally if needed by specific endpoints.
    // If your paths.user.update specifically needs FormData:
    const requestBody = new FormData();
    requestBody.append("first_name", body.first_name);
    requestBody.append("last_name", body.last_name);
    // If it takes JSON, then: const requestBody = body;

    try {
      // The token for APICall is the raw JWT string, not "Bearer " + jwt
      // APICall utility should add "Bearer " prefix if that's its convention.
      // Assuming jwt from useAuth() is already "Bearer <token>"
      const response = await APICall(
        "PUT",
        paths.user.update, // Make sure this path is correct
        requestBody, // Or 'body' if your API expects JSON for PUT
        undefined,
        jwt // Pass the JWT from useAuth()
      );

      console.log("AddInfo: Response from user/update:", response);

      if (response.status === "success" && response.response) {
        // Update the user object in AuthProvider's context
        updateUserInContext(response.response); // Pass the updated user object from API

        console.log("AddInfo: User data updated successfully in context.");
        navigate("/dashboard", { replace: true }); // Navigate to dashboard
      } else {
        setError(
          response.message ||
            "Failed to update user information. Please try again."
        );
      }
    } catch (err) {
      console.error("AddInfo: Error updating user info:", err);
      setError(err.message || "An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // If user somehow lands here but their profile is already complete, redirect.
  // ProtectedRoute in App.js should ideally prevent this, but this is an extra safeguard.
  useEffect(() => {
    if (user && user.first_name && user.last_name) {
      console.log(
        "AddInfo: User profile already complete, redirecting to dashboard."
      );
      navigate("/dashboard", { replace: true });
    }
  }, [user, navigate]);

  if (!user && !jwt) {
    // Or if still loading auth state from AuthProvider
    // This case should ideally be handled by ProtectedRoute redirecting to login.
    // If AuthProvider is still loading, show a loader.
    // const { isLoadingSession } = useAuth(); // Could use this
    // if (isLoadingSession) return <div>Loading...</div>;
    return (
      <div>Authenticating... (If you see this for long, there's an issue)</div>
    );
  }

  return (
    <div className="flex" style={{ height: "100vh" }}>
      {/* Left Part */}
      <div
        className="part1"
        style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
      >
        <div className="part1-img-container">
          <img src={SignUpHome} height={121} width={260} alt="RentPe Logo" />
        </div>
        <div>
          <p
            className="px-10"
            style={{ fontSize: 40, fontWeight: 700, color: "white" }}
          >
            <strong>Rent</strong> management made <strong>easy</strong> on{" "}
            <strong>RentPe</strong>
          </p>
        </div>
        <section className="mt-auto w-full text-center p-4 text-white">
          <p className="pb-4">
            <Link to="/privacy-policy">Privacy Policy</Link>
          </p>
          <span>© 2024 RentPe. All rights reserved.</span>
        </section>
      </div>

      {/* Right Part */}
      <div className="pl-24" style={{ flex: 0.8 }}>
        <div className="logo-signup-login pt-36 pb-12">
          <img src={Logo} alt="Logo" width={130} height={130} />
        </div>
        {/* <span>Register</span> */}
        <p style={{ fontSize: 24, fontWeight: 600 }}>Sign Up</p>
        {error && <p className="text-red-500 text-sm py-2">{error}</p>}
        <div className="flex flex-col w-96 py-6 gap-6">
          {" "}
          {/* Adjusted padding/gap */}
          <TextField
            id="first-name"
            label="First Name"
            variant="outlined"
            value={firstName} // Controlled component
            onChange={(e) => setFirstName(e.target.value)}
            error={firstName !== "" && !validateInput(firstName)} // Show error only if not empty and invalid
            helperText={
              firstName !== "" && !validateInput(firstName)
                ? "Only letters and spaces allowed"
                : ""
            }
            required
          />
          <TextField
            id="last-name"
            label="Last Name"
            variant="outlined"
            value={lastName} // Controlled component
            onChange={(e) => setLastName(e.target.value)}
            error={lastName !== "" && !validateInput(lastName)} // Show error only if not empty and invalid
            helperText={
              lastName !== "" && !validateInput(lastName)
                ? "Only letters and spaces allowed"
                : ""
            }
            required
          />
        </div>
        <p className="pb-6 w-96 text-xs">
          {" "}
          {/* Adjusted padding */}
          By selecting Confirm and Continue, I agree to RentPe Terms of Services
          and acknowledge the Privacy Policy.
        </p>
        <Button
          className="w-96 h-12"
          variant="contained"
          onClick={handleUpdateUserInfo}
          disabled={
            loading ||
            !firstName.trim() ||
            !lastName.trim() ||
            !validateInput(firstName) ||
            !validateInput(lastName)
          }
        >
          {loading ? "Saving..." : "Confirm and Continue"}
        </Button>
      </div>
    </div>
  );
}
